import React, { useContext } from 'react';
import { Dropdown, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { ThemeContext } from '../../context/ThemeContext';
import UserAvatar from './UserAvatar';
import { translateRole } from '../../i18n';

function Navbar() {
  const { t, i18n } = useTranslation();
  const { user, logout } = useContext(AuthContext);
  const { isDark, toggleTheme } = useContext(ThemeContext);
  const navigate = useNavigate();

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      document.body.classList.toggle('sidebar-icon-only');
    } else {
      const offcanvas = document.querySelector('.sidebar-offcanvas');
      if (offcanvas) {
        offcanvas.classList.toggle('active');
      }
    }
  };

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    navigate('/user-pages/login');
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <nav className='navbar col-lg-12 col-12 p-lg-0 fixed-top d-flex flex-row'>
        <div className='navbar-menu-wrapper d-flex align-items-stretch justify-content-between'>
          <div className="d-flex align-items-center">
            <a className='navbar-brand brand-logo-mini align-self-center me-2 d-lg-none' href="/dashboard" onClick={evt => evt.preventDefault()}>
              <img src='/images/rutex-simbolo.svg' alt='Rutex Simbolo' onError={(e) => { e.target.onerror = null; e.target.src = '/images/logo-mini.png'; }} style={{ height: '32px', objectFit: 'contain' }} />
            </a>
            <Button 
              variant='navbar-toggler' 
              className="align-self-center me-2 border-0 bg-transparent d-lg-none" 
              type='button' 
              onClick={handleToggleSidebar} 
              title="Alternar Menú Lateral"
            >
              <i className="mdi mdi-menu fs-4 text-white"></i>
            </Button>
          </div>

          <ul className='navbar-nav navbar-nav-right'>
            {/* Dark/Light Mode Theme Toggle Button */}
            <li className="nav-item border-0 me-2">
              <Button 
                variant="outline-secondary" 
                className="btn-icon rounded-circle border-0 text-white"
                onClick={toggleTheme}
                title={isDark ? "Cambiar a Modo Claro" : "Cambiar a Modo Oscuro"}
                style={{ width: '40px', height: '40px', padding: 0 }}
              >
                <i className={`mdi ${isDark ? 'mdi-weather-sunny text-warning' : 'mdi-weather-night'} fs-5`}></i>
              </Button>
            </li>

            {/* Language Selector */}
            <li className="nav-item d-none d-xl-flex border-0 me-2">
              <Dropdown>
                <Dropdown.Toggle className="nav-link count-indicator bg-transparent border-0 text-white">
                  <i className="mdi mdi-earth me-2"></i> {i18n.language && i18n.language.startsWith('es') ? 'Español' : 'English'} &nbsp;
                </Dropdown.Toggle>
                <Dropdown.Menu className="preview-list navbar-dropdown">
                  <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center" onClick={() => changeLanguage('es')}>
                    <span className="me-2">🇪🇸</span> Español
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center" onClick={() => changeLanguage('en')}>
                    <span className="me-2">🇺🇸</span> English
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>

            {/* User Profile Dropdown */}
            <li className="nav-item nav-profile border-0">
              <Dropdown>
                <Dropdown.Toggle className="nav-link count-indicator bg-transparent border-0 d-flex align-items-center">
                  <UserAvatar user={user} size="sm" className="ms-2" />
                  <div className="d-none d-md-block ms-2 text-start">
                    <span className="profile-name d-block fw-bold text-white" style={{ fontSize: '0.88rem', lineHeight: '1.2' }}>
                      {user ? user.nombre_completo : 'Administrador'}
                    </span>
                    <span className="text-white-50 small" style={{ fontSize: '0.75rem' }}>
                      {user ? translateRole(user.rol, t) : t('role_admin', 'Administrador')}
                    </span>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className="preview-list navbar-dropdown shadow-lg">
                  <div className="dropdown-header-custom text-center p-3">
                    <UserAvatar user={user} size="lg" className="mb-2 mx-auto" />
                    <h6 className="user-name mb-0">{user ? user.nombre_completo : 'Usuario'}</h6>
                    <small className="user-email d-block mt-1 text-muted">{user ? (user.email || user.username || '') : ''}</small>
                  </div>

                  <Dropdown.Item 
                    className="dropdown-item preview-item d-flex align-items-center" 
                    onClick={() => navigate('/general-pages/profile')}
                  >
                    <i className="mdi mdi-account-cog-outline"></i>
                    <span>Configuración de Perfil</span>
                  </Dropdown.Item>

                  <Dropdown.Divider />

                  <Dropdown.Item 
                    className="dropdown-item preview-item d-flex align-items-center text-danger" 
                    onClick={handleLogout}
                  >
                    <i className="mdi mdi-logout-variant"></i>
                    <span className="fw-semibold">Cerrar Sesión</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;